import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pnc_ic_wgzf",
  "use": "icon-pnc_ic_wgzf-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol viewBox=\"0 0 44 44\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pnc_ic_wgzf\"><path d=\"m10 14h24c2.2 0 4 1.8 4 4v16c0 2.2-1.8 4-4 4h-24c-2.2 0-4-1.8-4-4v-16c0-2.2 1.8-4 4-4z\" fill=\"#45a8ff\" /><path d=\"m25.8 7.2c1.8-.7 3.9 0 4.9 1.7l2.3 4h-22z\" fill=\"#45a8ff\" /><path d=\"m30 30c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pnc_ic_wgzf.svg
// module id = c37m
// module chunks = 87